var render = function render(_c,_vm){return _c('div',{staticClass:"verify-step2"},[_c('mm-icon',{attrs:{"name":"info","size":"80px"}}),_c('p',{directives:[{name:"t",rawName:"v-t",value:('auth.pending'),expression:"'auth.pending'"}],staticClass:"tips"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }